import { motion, useAnimate, type AnimationSequence } from 'framer-motion'
import { useCallback, useEffect, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useSub } from '../../../hooks/subscription/use-sub'
import { useGlobalStore } from '../../../store/global-store'
import type { LiveGiftsAnimations } from '../../../types/lives/animations'

const LIVE_GIFTS_ANIMATIONS = '/LIVE-GIFTS-ANIMATIONS'

export function GiftReceivedPerUser() {
  const searchParams = new URLSearchParams(window.location.search)
  const position = searchParams.get('position')

  const [giftReceived, setGiftReceived] = useState<string | null>(null)
  const [scope, animate] = useAnimate()

  const liveId = useGlobalStore(useShallow((state) => state.liveId))

  const checkGiftReceived = useCallback(
    ({ elementsToGo, imgGift }: LiveGiftsAnimations) => {
      for (const elementToGo of elementsToGo) {
        if (position === 'streamer' && elementToGo === 'streamer') {
          if (!giftReceived) setGiftReceived(imgGift)
        } else {
          if (Number(position) === Number(elementToGo) && !giftReceived) {
            setGiftReceived(imgGift)
          }
        }
      }
    },
    [giftReceived, position, setGiftReceived],
  )

  useSub<LiveGiftsAnimations>({
    endpoint: `${LIVE_GIFTS_ANIMATIONS}/${liveId}`,
    skip: !liveId,
    onData: checkGiftReceived,
  })

  useEffect(() => {
    const sequence: AnimationSequence = [
      [scope.current, { scale: 1.2 }, { duration: 0.2 }],
      [scope.current, { scale: 1 }, { duration: 0.2 }],
    ]

    if (giftReceived) {
      animate(sequence).then(() => setGiftReceived(null))
    }
  }, [giftReceived, scope, animate])

  return (
    <motion.div
      ref={scope}
      className="w-screen h-screen flex justify-center items-center bg-transparent"
    >
      {giftReceived && (
        <img src={giftReceived} className="w-10 h-10 bg-transparent" />
      )}
    </motion.div>
  )
}
